<template>
  <div class="container-fluid" style="user-select: none">
    <div class="row d-flex align-items-center">
      <div :class="`col-10 form-group form-group-md`">
        <div class="form-group">
          <label for="quickFilter" class="label">Filtro rapido</label>
          <input
            type="text"
            class="form-control"
            id="quickFilter"
            v-model="quickFilter"
          />
        </div>
      </div>
      <div class="col-2 form-group form-group-md">
        <label
          class="label form-check-label"
          for="mostrar_todos"
          style="cursor: pointer"
        >
          <input
            id="mostrar_todos"
            v-model="mostrarTodos"
            class="form-check-inline"
            style="zoom: 1.2; cursor: pointer"
            type="checkbox"
          />ver todos
        </label>
      </div>
    </div>
    <div class="row" style="height: 100%">
      <div class="col" style="position: relative; height: 100%">
        <ag-grid-vue
          style="width: 100%; height: 60vh"
          class="ag-theme-alpine"
          @grid-ready="onGridReady"
          :gridOptions="gridOptions"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :modules="modules"
          :rowData="rowData"
          :getRowStyle="getRowStyle"
          :statusBar="statusBar"
          :getContextMenuItems="getContextMenuItems"
        >
        </ag-grid-vue>
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { AllModules } from "ag-grid-enterprise";
import { get } from "lodash-es";
import { formatM } from "../../../lib/utils/accountingJsFns";

import UltimaFacturaComponent from "@/pages/Suspensiones/EvitarSuspensiones/Celdas/UltimaFacturaComponent";
import DeudaActualComponent from "@/pages/Suspensiones/EvitarSuspensiones/Celdas/DeudaActualComponent";
import FechaCompromisoComponent from "@/pages/Suspensiones/EvitarSuspensiones/Celdas/FechaCompromisoComponent";
import ResumenDeudoresActionButtons from "@/pages/Suspensiones/EvitarSuspensiones/Celdas/ResumenDeudoresActionButtons";
import fechaAltaComponent from "./fechaAltaComponent.vue";
import ReferenciaDeColoresSuspensiones from "./Celdas/ReferenciaDeColoresSuspensiones";
import CantidadDeSuspensionesATratarComponent from "./Celdas/CantidadDeSuspensionesATratarComponent";

export default {
  name: "ResumenDeudores",
  components: {
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    ReferenciaDeColoresSuspensiones,
    // eslint-disable-next-line vue/no-unused-components
    CantidadDeSuspensionesATratarComponent,
  },
  computed: {
    modo() {
      return this.$store.state.Suspensiones.suspensionesMODO;
    },
    columnDefsDynamic() {
      const columns = [
        {
          headerName: "Status",
          field: "estado",
          hide: true,
          flex: 1,
          cellRenderer: () => "",
          sort: "asc",
          comparator: (a, b, nodeA, nodeB) => {
            const estadoA = this.obtenerPrioridad(nodeA.data);
            const estadoB = this.obtenerPrioridad(nodeB.data);

            if (estadoA === estadoB) {
              return nodeA.data.id_cliente - nodeB.data.id_cliente;
            }

            return estadoA - estadoB;
          },
        },
        {
          headerName: "Cliente",
          field: "id_cliente",
          flex: 2,
          cellRenderer: (params) =>
            `${params.data.id_cliente} - ${params.data.nombre_web}`,
          getQuickFilterText: (params) =>
            `${params.data.id_cliente} - ${params.data.nombre_web}`,
          comparator: (a, b, nodeA, nodeB) => {
            nodeA.data.id_cliente - nodeB.data.id_cliente;
          },
          valueGetter: (params) =>
            `${params.data.id_cliente} - ${params.data.nombre_web}`,
        },
        {
          headerName: "Ultima Factura",
          field: "ultima_factura",
          flex: 2,
          cellRendererFramework: UltimaFacturaComponent,
          type: "rightAligned",
          getQuickFilterText: function (params) {
            return params.data.ultima_factura;
          },
          valueGetter: (params) => params.data.ultima_factura || "",
        },
        {
          headerName: "Deuda Actual",
          field: "deuda_actual",
          flex: 2,
          cellRendererFramework: DeudaActualComponent,
          type: "rightAligned",
          getQuickFilterText: function (params) {
            return params.data.deuda_actual;
          },
          valueGetter: (params) => params.data.deuda_actual || "",
        },
        {
          headerName: "Saldo a la fecha",
          field: "saldo_a_la_fecha",
          flex: 2,
          valueGetter: (params) => {
            return formatM(params.data.saldo_a_la_fecha);
          },
          type: "rightAligned",
          getQuickFilterText: function (params) {
            if (params.data.saldo_a_la_fecha)
              return params.data.saldo_a_la_fecha;
            else return "";
          },
          exportValueGetter: (params) => params.data.saldo_a_la_fecha || 0,
        },
        {
          headerName: "Compromiso de Pago",
          field: "fecha_compromiso",
          flex: 2,
          cellRendererFramework: FechaCompromisoComponent,
          getQuickFilterText: function (params) {
            if (params.data.fecha_compromiso)
              return params.data.fecha_compromiso;
            else return "";
          },
          valueGetter: (params) => params.data.fecha_compromiso || "",
        },
        {
          headerName: "Comentarios",
          field: "comentarios",
          flex: 2,
          cellRenderer: (params) =>
            params.data.comentarios ? `${params.data.comentarios}` : "",
          getQuickFilterText: (params) =>
            params.data.comentarios ? `${params.data.comentarios}` : "",
          valueGetter: (params) => params.data.comentarios || "",
        },
        {
          headerName: "Alta de cliente",
          field: "fecha_alta",
          cellRendererFramework: fechaAltaComponent,
          valueGetter: (params) => params.data.fecha_alta || "",
        },
        {
          headerName: "Suspensiones",
          flex: 1,
          field: "cantidad_suspensiones",
          valueGetter: (params) => params.data.cantidad_suspensiones || 0,
        },
        {
          headerName: "Acción",
          flex: 2,
          cellRendererFramework: ResumenDeudoresActionButtons,
        },
      ];

      if (this.modo === "evitar") {
        return columns.filter(
          (column) => column.field !== "cantidad_suspensiones",
        );
      } else {
        return columns;
      }
    },
    rowData: {
      get() {
        return get(this.$store, 'getters["Suspensiones/getDeudores"]', []);
      },
      set(val) {
        this.$store.commit("Suspensiones/setDeudores", val);
      },
    },
    mostrarTodos: {
      get() {
        return get(this.$store, 'getters["Suspensiones/getMostrarTodos"]', 0);
      },
      set(val) {
        this.$store.dispatch("Suspensiones/setMostrarTodos", val ? 1 : 0);
      },
    },
  },
  beforeDestroy() {
    if (this.gridApi) {
      this.gridApi = null;
    }
  },
  data: () => ({
    statusBar: null,
    quickFilter: "",
    modules: AllModules,
    gridApi: null,
    defaultColDef: null,
    columnDefs: [],
    gridOptions: {
      localeText: {
        noRowsToShow: "<strong>Sin ticket's a tratar</strong>",
      },
      defaultExcelExportParams: {
        fileName: "resumen_deudores.xlsx",
        sheetName: "Resumen Deudores",
        exportMode: "xlsx",
        suppressTextAsCDATA: true,
      },
      defaultCsvExportParams: {
        fileName: "resumen_deudores.csv",
        suppressQuotes: false,
      },
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    },
  }),
  methods: {
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
    obtenerPrioridad(data) {
      if (this.modo === "evitar") {
        if (data.a_tratar > 0) {
          return 1;
        } else if (data.suspendido > 0) {
          return 2;
        } else if (data.a_tratar === 0) {
          return 3;
        }
        return 4;
      } else {
        if (data.fecha_reconex) {
          return 2;
        } else {
          return 1;
        }
      }
    },
    getRowStyle(params) {
      if (this.modo === "evitar") {
        if (params.data.suspendido > 0) {
          return { backgroundColor: "rgb(216, 0, 50,0.5)" }; // rojo
        } else if (params.data.a_tratar === 0) {
          return { backgroundColor: "rgb(162, 255, 134,0.5)" }; //verde
        } else if (params.data.a_tratar > 0) {
          return { backgroundColor: "#fffff" }; //blanco
        }
      } else {
        if (params.data.fecha_reconex) {
          return { backgroundColor: "rgb(162, 255, 134,0.5)" }; //verde
        }
      }
    },
    async onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.showLoadingOverlay();
      const resp = await this.$store.dispatch("Suspensiones/getDeudores");

      if (!resp.ok) {
        await this.$msgBoxOk(resp.message);
        return;
      }

      const rowData = this.$store.getters["Suspensiones/getDeudores"] || [];
      const showNoRows = this.shouldShowNoRows(rowData);

      if (showNoRows) {
        this.gridApi.showNoRowsOverlay();
      } else {
        this.gridApi.hideOverlay();
      }
    },
    shouldShowNoRows(rowData) {
      if (!rowData || !rowData.length) return true;
      if (this.modo === "evitar") {
        const rowsATratar = rowData.filter((row) => row && row.a_tratar === 1);
        return !rowsATratar.length;
      }
      return false;
    },
    autoSizeAll(skipHeader) {
      let allColumnIds = [];
      this.gridColumnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    },
    async updateDeudores() {
      if (this.gridApi) {
        this.gridApi.showLoadingOverlay();
      }
      const resp = await this.$store.dispatch("Suspensiones/getDeudores");

      if (!resp.ok) {
        await this.$msgBoxOk(resp.message);
      }

      if (this.gridApi) {
        const rowData = this.$store.getters["Suspensiones/getDeudores"];
        if (
          this.modo === "evitar" &&
          !rowData.some((row) => row.a_tratar === 1)
        ) {
          this.gridApi.showNoRowsOverlay();
        } else if (this.modo !== "evitar" && !rowData.length) {
          this.gridApi.showNoRowsOverlay();
        } else {
          this.gridApi.hideOverlay();
        }
      }
    },
  },
  watch: {
    modo() {
      this.$store.dispatch("Suspensiones/setMostrarTodos", 0);
    },
    mostrarTodos() {
      this.updateDeudores().then(() => {});
    },
    columnDefsDynamic: {
      handler(newVal) {
        this.columnDefs = newVal;
      },
      immediate: true,
    },
    quickFilter(val) {
      if (this.gridApi) {
        this.gridApi.setQuickFilter(val);
      }
    },
  },
  beforeMount() {
    this.statusBar = {
      statusPanels: [
        {
          statusPanel: "agTotalAndFilteredRowCountComponent",
          align: "left",
        },
        {
          statusPanel: "CantidadDeSuspensionesATratarComponent",
          align: "center",
        },
        {
          statusPanel: "ReferenciaDeColoresSuspensiones",
          align: "right",
        },
        { statusPanel: "agFilteredRowCountComponent" },
        { statusPanel: "agSelectedRowCountComponent" },
        { statusPanel: "agAggregationComponent" },
      ],
    };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      suppressNavigable: false,
      enableCellChangeFlash: false,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    };
  },
};
</script>

<style scoped></style>
